import { Component, Input } from '@angular/core';
import { iRankingRow } from '../ranking.interface';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationService } from '@app/services/navigation/navigation.service';

@Component({
  selector: 'app-ranking-row',
  standalone: true,
  imports: [
		SharedModule,
	],
  templateUrl: './ranking-row.component.html',
  styleUrl: './ranking-row.component.scss'
})
export class RankingRowComponent {
	@Input() row!: iRankingRow;
	public showDeaths: boolean = false;

	constructor(private navigation: NavigationService) { }

	public toggleDeaths = () => this.showDeaths = !this.showDeaths;

	public goToDeadView = (id: number | string, name: string) => this.navigation.goDeadView(id, name);

}
